import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Transition, config } from 'react-spring';
import PubSub from 'pubsub-js';

import Container from './Container';
import Text from './Text';

const defaultType = 'message';
const defaultMessage = 'Copied!';
const defaultTimeout = 3000;

@observer
export default class PopupTextDisplay extends Component {
  timeout = defaultTimeout;

  @observable type = defaultType;
  @observable message = defaultMessage;
  @observable shouldShowDisplay = false;

  @action triggerDisplay = (msg, message) => {
    if (typeof message === 'string') {
      this.type = defaultType;
      this.timeout = defaultTimeout;
      this.message = message || defaultMessage;
    } else if (typeof message === 'object') {
      this.type = message.type || defaultType;
      this.timeout = message.timeout || defaultTimeout;
      this.message = message.message || defaultMessage;
    } else {
      this.type = defaultType;
      this.timeout = defaultTimeout;
      this.message = defaultMessage;
    }

    this.showDisplay();
  };

  @action showDisplay = () => {
    this.shouldShowDisplay = true;
    clearTimeout(this.triggerTimeout);
    this.triggerTimeout = setTimeout(this.hideDisplay, this.timeout);
  };

  @action hideDisplay = () => (this.shouldShowDisplay = false);

  componentDidMount() {
    this.listener = PubSub.subscribe('popup-text', this.triggerDisplay);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.listener);
  }

  render() {
    return (
      <Transition
        native
        items={this.shouldShowDisplay}
        from={{ transform: 'translate3d(0,3rem,0) scale(0.7)' }}
        enter={{ transform: 'translate3d(0,-0.5rem,0) scale(1.1)' }}
        leave={{ transform: 'translate3d(0,5rem,0) scale(0.8)' }}
        config={{ ...config.wobbly, tension: 200, mass: 1.2 }}>
        {shouldShowDisplay =>
          shouldShowDisplay &&
          (animation => (
            <Container>
              <Text style={animation} type={this.type}>
                {this.message}
              </Text>
            </Container>
          ))
        }
      </Transition>
    );
  }
}
